module.exports = __webpack_public_path__ + "img/chartLineIcon.ac39b62a.svg";